import "../styles/AquaFlowPromo.scss";
import aquaflow from "../assets/marketing/calor.png";
import aquaflow_graph from "../assets/marketing/calor_graph.png";

const Calor = () => {
  return (
    <section className="aqua-flow-promo">
      <img src={aquaflow} alt="Aqua Flow Banner" className="top-image" />

      <div className="features">
        <div>
          <h3>PRINCIPAIS FUNÇÕES</h3>
          <p>
            Com a bomba de calor para aquecimento central, você ESQUENTA E
            RESFRIA NÃO APENAS A ÁGUA, MAS TAMBÉM O SEU AMBIENTE, criando uma
            experiência integrada que pode ser controlada remotamente pelo seu
            aplicativo.
          </p>
        </div>
        <div>
          <h3>APLICAÇÕES</h3>
          <p>
            Ela é ideal para construções residenciais de médio e grande porte,
            como casas de praia, fazendas e chácaras. No setor comercial, atende
            todos os tipos de empreendimentos, incluindo hotéis, pousadas,
            restaurantes, hospitais, academias e indústrias.
          </p>
        </div>
        <div>
          <h3>COMO FUNCIONA</h3>
          <p>
            É um sistema eficiente que utiliza o calor do ar ambiente para
            aquecer a água. Ao contrário de aquecedores tradicionais que geram
            calor queimando combustíveis ou usando eletricidade diretamente, a
            bomba de calor transfere o calor presente no ar para a água do
            reservatório.
          </p>
        </div>
      </div>
      <div className="button-wrapper">
        <a
          href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+serviços+de+${"bombas+de+calor"}.`}
          target="_blank"
          style={{ color: "inherit" }}
        >
          <button>Solicite seu orçamento</button>
        </a>
      </div>

      <img
        src={aquaflow_graph}
        alt="Gráfico de desempenho"
        className="bottom-image"
      />
    </section>
  );
};

export default Calor;
